import React, { useEffect, useState } from "react";
import { getbustrips, getBusTripsExport } from "../../services/TransportService";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { PiExportBold } from "react-icons/pi";
import { Tooltip } from "@mui/material";
import format from "date-fns/format";
import { renderTripDuration } from "../../utilities";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CustomTooltip } from "../../components/CustomTooltip";
const parseTime = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  const now = new Date();
  now.setHours(hours, minutes, seconds || 0, 0);
  return now;
};
const Bustrip = ({ busId }) => {
  const { id } = useParams();
  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
  });
  const [exportloading, setExportloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setLoading(true);
    getbustrips(busId || id, param)
      .then((res) => {
        setData(res?.data?.results);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param, id, busId]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
   const handleexport = () => {
      setExportloading(true);
      const newparam = { ...param, export: true };
      getBusTripsExport(id,newparam)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
  
          const a = document.createElement("a");
          a.href = url;
          a.download = "Bus-trips.xlsx"; // set your desired filename
          a.click();
  
          window.URL.revokeObjectURL(url); // clean up
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setExportloading(false);
        });
    };
  return (
    <div>
      <div className="d-flex justify-content-end px-1 mb-2">
        <div className="d-flex gap-1">
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
          <CustomTooltip title="Export" arrow>
            <span
              className="cursor-pointer d-inline-flex align-items-center justify-content-center bus-action-button me-2"
              style={{padding:'11px'}}
              onClick={handleexport}
              // style={{
              //   padding: "0px 15px",
              //   backgroundColor: "rgb(226, 225, 225)",
              //   borderRadius: "5px",
              // }}
              // style={{ width: "24px", height: "24px" }}
            >
              {exportloading ? (
                <Spinner animation="border" variant="primary" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
            </span>
          </CustomTooltip>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : !data || data.length === 0 ? (
          <div className="p-2 text-center">There are no records found.</div>
        ) : (
          <div className="table-responsive pb-2">
            <table className="table fs-6 align-middle mb-0">
              <thead className="custom-thead table-light">
                <tr>
                  <th>Route Name</th>
                  <th>Shift Name</th>
                  <th>Driver</th>
                  <th>Trip Duration</th>
                  <th>Passes</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => {
                  const start = parseTime(row.start_time);
                  const end = parseTime(row.end_time);
                  const tripDuration =
                    start && end
                      ? `${format(start, "hh:mm a")} - ${format(
                          end,
                          "hh:mm a"
                        )}`
                      : "-";

                  const tripModeClass =
                    row?.trip_mode?.toLowerCase() === "pickup"
                      ? "text-bg-success-soft"
                      : "text-bg-info-soft";

                  return (
                    <tr key={index}>
                      <td>{row.route?.name || "N/A"}</td>
                      <td>{row.shift?.name || "N/A"}</td>
                      <td>{row.driver?.name || "N/A"}</td>
                      <td>
                        <span>{renderTripDuration(start, end)}</span>
                        <br></br>{" "}
                        <span className={`badge rounded-pill ${tripModeClass}`}>
                          {row.trip_mode || "N/A"}
                        </span>
                      </td>
                      <td>{row.total_pass ?? "N/A"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination - if not loading and data exists */}
        {!loading && data && data.length > 0 && (
          <div className="px-2 border-top">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Bustrip;
